<template>
  <v-card flat color="transparent" class="mt-n9">
    <v-row>
      <v-col cols="12">
        <v-radio-group v-model="questionAnswer" :error-messages="errorMessage">
          <v-radio
            v-for="opt in computedQuestionOpts"
            :key="opt.questionOptId"
            :label="opt.optLabel"
            :value="opt"
            :color="themeColor"
          >
            <template #label>
              <v-card flat>
                <v-row no-gutters :class="opt.etcOption ? '' : ''">
                  <v-col cols="12" class="d-flex align-center flex-wrap">
                    <v-img
                      v-if="opt.attachment"
                      max-width="100px"
                      max-height="200px"
                      contain
                      :src="opt.attachment.filePathUri"
                    ></v-img>
                    <span>{{ opt.optLabel }}</span>
                    <v-text-field
                      style="width:300px"
                      v-if="opt.etcOption"
                      class="pl-3"
                      v-model="etcOptTextVal"
                      hide-details="auto"
                      dense
                      outlined
                      single-line
                      :disabled="!hasEtcOption"
                      :errorMessage="etcErrorMessage"
                      :color="themeColor"
                      :placeholder="$t('구체적인 내용을 입력해주세요.')"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-card>
            </template>
          </v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { validate } from "vee-validate";
import _ from "lodash";

export default {
  props: {
    question: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
    },
    isValid: {
      type: Boolean,
      default: false,
    },
    themeColor: {
      type: String,
      default: "primary",
    },
    responseAnswer: Object,
  },
  computed: {
    computedQuestionOpts(){
      return _.orderBy(
        this.question.questionOpts || [],
        [
          (opt) => opt.noneOfAbove,
          (opt) => opt.etcOption,
          "optSortNo"],
        ["asc","asc","asc"]
      );
    },
    questionAnswers() {
      let qa = null;
      let etcOptId = null;
      let etcOptVal = null;

      if (this.questionAnswer != null) {
        qa = [this.questionAnswer.questionOptId];
        etcOptId = this.questionAnswer.etcOption
          ? this.questionAnswer.questionOptId
          : null;
        etcOptVal = this.questionAnswer.etcOption ? this.etcOptTextVal : null;
      } else {
        qa = [];
      }
      return {
        questionId: this.question.questionId,
        questionMatrixId: null,
        questionAnswerVals: qa,
        questionType: this.question.questionType,
        etcOptId: etcOptId,
        etcOptVal: etcOptVal,
      };
    },
    hasEtcOption() {
      return this.questionAnswer && this.questionAnswer.etcOption
        ? this.questionAnswer.etcOption
        : false;
    },
  },
  data() {
    return {
      questionAnswer: null,
      validationOptions: JSON.parse(this.question.validationOptions),
      errorMessage: [],
      etcErrorMessage: [],
      etcOptTextVal: null,
    };
  },
  methods: {
    async checkValidation() {
      let rules = {};
      if (this.question.required) {
        rules["required"] = true;
      }
      if (this.hasEtcOption && !this.etcOptTextVal) {
        this.$emit("update:isValid", false);
        this.etcErrorMessage = this.$t("기타 옵션 내용을 입력하세요.");
        return;
      } else {
        this.$emit("update:isValid", true);
      }

      let rst = await validate(this.questionAnswer, rules, { name: "이 " });
      this.$emit("update:isValid", rst.valid);
      this.errorMessage = rst.errors;
    },
    setQuestionAnswer() {
      // 선택값 세팅
      if (this.responseAnswer.response.length > 0) {
        let questionOptId = this.responseAnswer.response[0].questionOptId;
        this.questionAnswer = this.question.questionOpts.find(opt => {
          return opt.questionOptId == questionOptId;
        })
        // 선택값이 기타인 경우 기타 입력값 세팅
        this.etcOptTextVal = this.responseAnswer.response[0].etcOption ? this.responseAnswer.response[0].answerVal : null;
      } else {
        this.questionAnswer = null;
        this.etcOptTextVal = null;
      }
    },
  },
  watch: {
    async questionAnswer() {
      await this.checkValidation();
      this.$emit("input", this.questionAnswers);
    },
    async etcOptTextVal() {
      await this.checkValidation();
      this.$emit("input", this.questionAnswers);
    },
  },
  mounted() {
    if (this.responseAnswer) {
      this.setQuestionAnswer();
    }
    this.$emit("input", this.questionAnswers);
  },
};
</script>

<style></style>
